import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Layout::Stack style={{this.style}} @gap=\'small\'>\n  {{#if @hasArrow}}\n    <div style={{this.arrowStyle}}></div>\n  {{/if}}\n\n  {{yield}}\n</Layout::Stack>")